/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {registerProps as Éµa} from './footer.props';